module.exports = __webpack_public_path__ + "img/question-circle-thin.48b7ff5e.svg";